module.exports = __webpack_public_path__ + "c37ab7ed.svg";